var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReviews = function SvgReviews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 41 40",
    fill: "#B8B8B8",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m41 15.242-14.74-1.305L20.5 0l-5.76 13.958L0 15.242 11.193 25.2 7.831 40 20.5 32.147 33.169 40l-3.341-14.8L41 15.242ZM20.5 28.211V8.632l3.506 8.505 8.979.8L26.178 24l2.05 9.011-7.728-4.8Z"
  })));
};
export default SvgReviews;